import { useMemo } from 'react';
import { useContactHistory } from '../providers';
import { CallInsightHistoryPanel } from './call-insight-history-panel';
import { DefaultHistoryPanel } from './default-history-panel';

// Mapping of scopes to their respective components
const scopeComponentRegistry: Record<string, React.FC<{ personId: string }>> = {
  patientInsight: CallInsightHistoryPanel,
};

export const HistoryPanel = ({ personId }: { personId: string }) => {
  const { filters } = useContactHistory();

  const Component = useMemo(() => {
    const matchingScope = filters.find((filter) => scopeComponentRegistry[filter.scope]);
    return matchingScope ? scopeComponentRegistry[matchingScope.scope] : DefaultHistoryPanel;
  }, [filters]);

  return <Component personId={personId} />;
};
